/**
 * Inställningar för inloggningsläge
 * Möjliggör en simplifierad vy utan aktiv patient, meny och flikar, skapad i första hand för en anonymiserad version av Pågående operation.
 */

import PagaendeOperation from "@/tabs/Operation/PagaendeOperation.vue";
import ReceptforskrivningStart from "@/tabs/Receptforskrivning/Start/ReceptforskrivningStart.vue";

const getDefaultState = () => {
    return {
        pathname: "/",
        enableActivePatient: true,
        showMenu: true,
        showTabs: true,
        anonymousData: false,
        component: null,
        showProfile: true,
    };
};

const AVAILABLE_SETTINGS = {
    "/": {
        enableActivePatient: true,
        showMenu: true,
        showTabs: true,
        enableIdle: true,
        anonymousData: false,
        component: null,
        showProfile: true,
    },
    "/pagaendeop": {
        enableActivePatient: false,
        showMenu: false,
        showTabs: false,
        enableIdle: false,
        anonymousData: true,
        component: PagaendeOperation,
        showProfile: false,
    },
    "/nll": {
        enableActivePatient: false,
        showMenu: false,
        showTabs: true,
        enableIdle: true,
        anonymousData: false,
        component: ReceptforskrivningStart,
        showProfile: false,
    },
};

export default {
    namespaced: true,
    state: getDefaultState(),
    mutations: {
        reset(state) {
            Object.assign(state, getDefaultState());
        },
        setSettings(state, { pathname, settings }) {
            state.pathname = pathname;

            for (const key in settings) {
                state[key] = settings[key];
            }
        },
        setPathname(state, pathname) {
            state.pathname = pathname;
        },
        setEnableActivePatient(state, enableActivePatient) {
            state.enableActivePatient = enableActivePatient;
        },
        setShowMenu(state, showMenu) {
            state.showMenu = showMenu;
        },
        setShowTabs(state, showTabs) {
            state.showTabs = showTabs;
        },
        setAnonymousData(state, anonymousData) {
            state.anonymousData = anonymousData;
        },
    },
    getters: {
        pathname(state) {
            return state.pathname;
        },
        enableActivePatient(state) {
            return state.enableActivePatient;
        },
        showMenu(state) {
            return state.showMenu;
        },
        showTabs(state) {
            return state.showTabs;
        },
        // Använder inte state och getters, som är de två första in-params
        enableIdle(_, __, rootState) {
            return rootState.idle.enableIdle;
        },
        anonymousData(state) {
            return state.anonymousData;
        },
        showProfile(state) {
            return state.showProfile;
        },
        component(state) {
            return state.component;
        },
    },
    actions: {
        setSettings({ commit }, pathname) {
            const settings = AVAILABLE_SETTINGS[pathname];

            const { enableIdle, ...allSettings } = settings;

            commit("setSettings", { pathname, settings: allSettings });
            commit("idle/setEnableIdle", enableIdle, { root: true });
        },
        async launchView({ state, dispatch }) {
            if (state.component) {
                await dispatch("tabs/openTab", { component: state.component }, { root: true });
            }
        },
    },
};
